import { render, staticRenderFns } from "./menu-header-row.vue?vue&type=template&id=63d91905&scoped=true"
import script from "./menu-header-row.vue?vue&type=script&lang=js"
export * from "./menu-header-row.vue?vue&type=script&lang=js"
import style0 from "./menu-header-row.vue?vue&type=style&index=0&id=63d91905&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d91905",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuHeaderAllBrands: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-header-all-brands.vue').default,MenuHeaderChargesTile: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-header-charges-tile.vue').default,MenuHeaderMenuFormatter: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-header-menu-formatter.vue').default,MenuShare: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-share.vue').default,MenuAddDropdown: require('/home/runner/work/foaps-v2/foaps-v2/components/menu/menu-add-dropdown.vue').default})
